import {Mapper} from '@s-ui/domain'

export class FromTagsListToFormattedTagsListNewsValueObjectMapper extends Mapper {
  constructor({config, fromTagToFormattedTagNewsValueObjectMapper, newsTagsListValueObjectFactory}) {
    super()
    this._config = config
    this._fromTagToFormattedTagNewsValueObjectMapper = fromTagToFormattedTagNewsValueObjectMapper
    this._newsTagsListValueObjectFactory = newsTagsListValueObjectFactory
  }

  setParams = ({tags}) => {
    this._tags = tags
    return this
  }

  map = () =>
    this._newsTagsListValueObjectFactory({
      items: this._tags.map(tag => this._fromTagToFormattedTagNewsValueObjectMapper.setParams({tag}).map())
    })
}
